module.exports = __webpack_public_path__ + "static/media/group_3.891c70d6.svg";